import { render, staticRenderFns } from "./D-3-1__QuiktipsCreateEdit_Info.vue?vue&type=template&id=a4e8115a&"
import script from "./D-3-1__QuiktipsCreateEdit_Info.vue?vue&type=script&lang=js&"
export * from "./D-3-1__QuiktipsCreateEdit_Info.vue?vue&type=script&lang=js&"
import style0 from "./D-3-1__QuiktipsCreateEdit_Info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VIcon})
